export default class Steppable {
    public step!: number
    public min = 0
    public max!: number

    constructor(max: number, current = 0) {
        this.max = max
        if (this.check(current)) this.step = current
    }
    public previous() {
        if (this.step > 0) this.step--
    }
    public next() {
        if (this.step < this.max) this.step++
    }
    public goToStep(id: number) {
        if (this.check(id)) this.step = id
    }

    public check(id: number) {
        return id >= this.min && id <= this.max
    }
}
